// extracted by mini-css-extract-plugin
module.exports = {"nutritionScoreStyle":"_2YFRGqG3OTIHqBPsV9ObCA"};